/**
 * Returns true if being prerendered by react-snap. Useful for stuff
 * that needs to only run client-side and not during prerendering
 */
// navigator.userAgent => contains information about the name, version and platform of the browser.
const prerender = navigator.userAgent === 'ReactSnap';
export default prerender;
